import { ProfileDetailsType } from '@lib/types/profile'
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'

type ProfileDetailsContextValueType = {
  profileDetails: ProfileDetailsType
  setProfileDetails: Dispatch<SetStateAction<ProfileDetailsType>>
}

const ProfileContext = createContext<ProfileDetailsContextValueType>(
  {} as ProfileDetailsContextValueType
)
export const useProfileContext = () => useContext(ProfileContext)

type Props = {
  value: ProfileDetailsType
  children: JSX.Element | JSX.Element[]
}

export const ProfileContextProvider = ({ children, value }: Props) => {
  const [profileDetails, setProfileDetails] = useState<ProfileDetailsType>(
    value
  )
  return (
    <ProfileContext.Provider value={{ profileDetails, setProfileDetails }}>
      {children}
    </ProfileContext.Provider>
  )
}
